import { getStrings } from '../Common/Localization/commonStrings';

const localizedStrings = {
  PaperlessBilling: {
    strings: {
      en: {
        AlertName1: "Paperless ",AlertName2: "Billing ",
        AlertExp: "Get your statements online.",AlertType: "Pb",
        AccountPreferenceLabel: 'Account Preferences',
        popupMsg: 'Our records show your account(s) may be enrolled in Paperless Billing, but we need your email address for your bill notifications. Please visit the Preference Center and enter your email address, or you may choose to unenroll from Paperless Billing.',
        dialogRole:'dialog',ariaDescribe:'popupMessage_desc',defaultButton:'default',okButton:'Ok',
      },
      es: {}
    },
    common: ['globalError']
  },
  RepairMaintenanceAlerts: {
    strings: {
      en: {
        outageHeader1: "Repair and Maintenance ", outageHeader2: "Alerts ",
        outageHeaderSubTxt: "Stay informed about unplanned repair and planned maintenance outages.",
        outageTuronHeader: "Turn On Repair and Maintenance Outage Alerts",
        outageSetNotiFor: "Set alerts for: ",
        outgEmailNotiTxt: "Email Alerts", outgTextNotiTxt: "Text Alerts",outgEmailAddInfo:"You will receive email outage alerts 24/7.",
        outgTextAdditnlInfo: "You will receive text outage alerts 24/7.",
        outgVoiceNotiTxt: "Voice Alerts",
        outgDirectMailAlertTxt: "Direct Mail Alerts",
        outgDirectMailAlert1: "I wish to receive",
        outgDirectMailAlert2: " planned maintenance outage alerts",
        outgDirectMailAlert3: " mailed directly to my service address.",
        outgVoiceAdditnlInfo: "You will receive voice outage alerts between the hours of 9 a.m. and 9 p.m. Email and Text alerts will be sent 24/7.",
        outgAddEmail: "Add email", outgAddPhone: "Add phone",
        outgTurnOnBtn: 'Turn On Outage Alerts',
        outgTnCRead: 'I have read and agree to the Terms and Conditions.',
        viewEditHeader:'View / Edit Repair and Maintenance Outage Alerts',
        viewEditSubHeader:'Set alerts for:',
        viewEditBtnTxt:'Done',
        turnOffHeader:'Turn Off Repair and Maintenance Outage Alerts',
        turnoffDescription:'Are you sure you want to turn off Repair and Maintenance outage alerts for this Account?',
        turnOffBtn:'Yes, Turn Off Outage Alerts',
        cancelButton:'Cancel', removeButton:'Remove', editButton:'Edit',
        errorMsg:'Something went wrong on our end.',
        Resubmit:'Click here to resubmit',
        addBtnName:'Add', saveBtnName:'Save',
        outgShowMore: 'Show More', outgShowLess: 'Show Less',
        emailSameValueErrorMsg:'Email already exists',
        voiceSameValueErrorMsg:"Phone number already exists",
        textSameValueErrorMsg:"Phone number already exists",
        atleastOnePrefErrMsg:'You must add at least one contact for notifications.',
        limitText:'(limit 3 contacts)',
        tncError:"You must agree to the Terms and Conditions."
      },
      es: {}
    },
    common: ['globalError', 'cancel']
  },
  BaAlerts: {
    strings: {
      en: {
        budaHeader1: "Budget Assistant ",budaHeader2:"Notifications ",budaHeaderSubTxt: "Get early warning of projected high usage charges.",
        budaViewEditBtn: "View / Edit",budaTuronHeader: "Turn On Budget Assistant Notifications",
        budaSetNotiFor: "Set notifications for: ",
        budaSetSpendingGoal: "Set Spending Goals", budaSetGoalNo: "1",
        budaSetGoalSummer: "Summer", budaSetGoalWinter: "Winter",
        budaSetGoalSummerTerm: "June - September",budaSetGoalWinterTerm: "October - May",
        budaSetGoalSummerAvg: "Your average summer bill is $",
        budaSetGoalWinterAvg: "Your average winter bill is $",
        budaSetGoalDisclaimer: "* Based on last 12 months.",
        budaSetGoalOverErr: "Goal must be less than $1,500.",
        budaSetGoalUnderErr: "Goal must be greater than $20.",
        budaChooseContacts: "Choose Contacts", budaChooseContactsNo: "2",
        budaEmailNotiTxt: "Email Notifications",
        budaTextNotiTxt: "Text Notifications",
        budaVoiceNotiTxt: "Voice Notifications",
        budaAddEmail: "Add email", budaAddPhone: "Add phone",
        budaSelectFrequency: "Select Frequency",
        budaSelFrqucyNo: "3",
        budaFrqncyOnlyOverGoal: "Only if I'm over my spending goal",
        budaFrqncyWeekly: "Weekly", budaFrqncyMonthly: "Mid-Month",
        budaTurnOnBtn: 'Turn On Notifications',
        budaTnCRead: 'I have read and agree to the Terms and Conditions.',
        cancelButton:'Cancel', removeButton:'Remove', editButton:'Edit',
        errorMsg:'Something went wrong on our end.',
        reSubmit:'Click here to resubmit',
        addBtnName:'Add', saveBtnName:'Save',
        budaShowMore: 'Show More', budaShowLess: 'Show Less',
        emailSameValueErrorMsg:'Email already exists',
        voiceSameValueErrorMsg:"Phone number already exists",
        textSameValueErrorMsg:"Phone number already exists",
        atleastOnePrefErrMsg:'You must add at least one contact for notifications.',
        limitText:'(limit 3 contacts)',
        erroMessage: "Our records indicate that you are not eligible for Budget Assistant. Error Code 993 - 32.",
        uPreferenceError:'Sorry something went wrong. Please try again later.' ,
        budaTuroffHeader:'Turn Off Budget Assistant Notifications',
        budaturnoffDescription:'Are you sure you want to turn off Budget Assistant Notifications for this address?',
        budaTurnOffBtn:'Yes, Turn Off Notifications',
        budaIneligibleErrMsg: "Our records indicate that you're not eligible for the Budget Assistant due to your rate type.",
        budaProcessingErrMsg:'Your earlier request to turn off Budget Assistant Notifications is still being processed. To turn them on again, please wait 24 hours before initiating your request.',
        budaTnCPrint: 'Print', baTNCHeaderText:'Terms & Conditions',
        viewEditHeader:'View / Edit Budget Assistant Notifications',
        viewEditSubHeader:'Set notifications for:',
        viewEditBtnTxt:'Done',
        viewEditChooseContacts: "Edit Contacts",
        viewEditSetSpendingGoal: "Edit Spending Goals",
        viewEditSelectFrequency: "Edit Frequency",
        tncError:"You must agree to the Terms and Conditions."
      },
      es: {}
    },
    common: ['globalError']
  },
  CppAlerts: {
    strings: {
      en: {
        AlertName1: "Critical Peak Pricing ",
        AlertName2: "Notifications ",
        AlertExp: "Plan for Critical Peak Pricing events.",
        emailSameValueErrorMsg:'Email already exists',
        voiceSameValueErrorMsg:"Phone number already exists",
        textSameValueErrorMsg:"Phone number already exists",
      },
      es: {}
    },
    common: ['globalError']
  },
  CustomerPreference: {
    strings: {
      en: {
        OutageLanguage: 'Notification Language',
        OutageLanguageDescription: 'Multiple language options are available for Public Safety Power Shutoff  alerts and repair/maintenance alerts only. Language options will be expanded to encompass additional alert and notification types in the future.',
        LanguageLabel: 'English', ButtonLabel: 'Edit',
        CustomerPreferenceLabel: 'Customer Preferences',
        OnLoadError: 'Sorry, we can’t retrieve your SCE Updates preference.',
        RefreshText: 'Click here to refresh',
        RegistrationError: 'There is a problem processing your request.',
        editNotificationLang: 'Edit Notification Language',
        modifyLanguageError:'Something went wrong on our end.',
        clickReSubmitText:'Click here to resubmit.',
        langDropDownErrorMsg: 'Please select a language',
        save: 'Save', cancel: 'Cancel',
        languageLodingError: 'Sorry, we can\'t retrieve your Notification Language preference. ',
        editLanguagePopupHeader: 'Edit Notification Language',
        
      },
      es: {}
    },
    common: ['globalError']
  },
  contentSection: {
    strings: {
      en: {
        ManageAccSettingsBtn: 'Manage Profile Settings',
        NeedToUpdateheader: ' Need to update your customer information?',
        LanguageLabel: 'Website Language: ',
      },
      es: {}
    },
    common: ['globalError']
  },
  CentralizedContainer: {
    strings: {
      en: {
        BannerLabel: 'PREFERENCE CENTER',
        BannerSubText: 'Decide which notifications to receive',
        CustomerPreferenceLabel: 'Customer Preferences',
        ErrorMainText:'Sorry, something went wrong on our end.',
        ErrorSubText: 'Our system is temporarily unable to locate the requested page. Please make your selection again.',
        ErrorBpTextOne:'The information you provided does not match any customers we have on ﬁle. Please try again. Error Code 2343 - B01.',
        ErrorBpTextTwo:'The information you provided does not match any customers we have on ﬁle. Please try again Or call 1-800-284-2365 to speak to a representative. Error Code 2343 - B01.',
        accountTypeSingle: 'Single'
      },
      es: {}
    },
    common: ['globalError']
  },
  AccountPreference: {
    strings: {
      en: {
        AccountPreferenceLabel: 'Account Preferences',
        errMsg: 'Sorry, we can’t retrieve your Account Preferences',
        errSubMsg: 'We couldn’t retrieve your preferences. Please try again…',
        contractSubMsg: 'We couldn’t retrieve your Account Details. Please try again…',
        AccountEnding: ' - Account ending ', Acct:' - Acct. ',
        searchErrMsgOne:'No accounts matched your search. You can search by exact ',
        cityError:'city name.',streetnameError:'street name.',streetnumError:'street number.', accountError:'account number.', zipError:'zip code.',
        NoAccountMsge1:'There are no service accounts associated with your User ID.',
        NoAccountMsge2:'If you’re an SCE customer, you can link your existing Customer Account to your SCE.com User ID. ',
        LearnMore:'Learn more'
      },
      es: {}
    },
    common: ['globalError']
  },
  ErrorCard: {
    strings: {
      en: {
        BpMatchTextOne:"You're currently not authorized to view this account. Please contact the account holder to review your authorization. Error Code 2343 – B01.",
        BpMatchTextTwo:"To view this account, please first verify your credentials with the account holder and then re-enter those credentials below.",
        FirstName: 'First Name',LasttName: 'Last Name',Email: 'Email Id',
      },
      es: {}
    },
    common: ['globalError']
  },
  GuestFlow: {
    strings: {
      en: {
        guestPreferenceLabel: 'Choose how to access your Preferences',
        ratePreferenceLabel: 'Login or Verify Your Identity to submit the Rate change request',
        logInLabel: 'Log In',or: 'OR',
        loginUserLabel: 'User ID / Email', oneTimeCode:'One-Time Code',
        loginPwdLabel: 'Password',logInBtnValue: 'Login', forgotPassword: 'Forgot password?',
        globalError: "We're sorry the username or password you entered does not match our records. Please re-enter your information and try again. If you continue to have issues, please try to \
        <a style='text-decoration:underline;' href='/user-registration'> Register </a>\
        your account or \
        <a style='text-decoration:underline;' href='/mysce/resetpassword'>Reset your Password.</a>",
        firstName: 'First Name', lastName: 'Last Name',emailOrPhone: 'Email or Phone', next: 'Next',
        ok:'OK',
        emailOrPhoneReqErrMsg: 'Email or Phone is required.',errorCodeEmpty:'Please enter a valid verification code',invalidCode:`It looks like the code you've entered may have expired or is incorrect. Click "Resend Code" for a new code to be sent to your device.`,
        validEmailOrPhoneErrMsg: 'Please enter a valid email or phone number.',
        verifyPhoneSubText:'To ensure your account’s security, we will send a verification code to a phone number we have on file.',
        textMe:'Text Me', callMe:'Call Me', sendCode: 'SEND CODE', cancel:'CANCEL', codeNotReceivedQn: 'Didn’t receive a code or need another?',
        verifyPhoneFooter:"If you wish to use a number not listed here to verify your identity, please call <span style='color:#1A76C5'>1-800-284-2365</span> to speak with a representative.", noPhNum:'No Phone Number',
        checkYourPhone:'Check Your Phone',textVerification:'Enter the 6-digit verification code we sent to:', verificationCode: 'Enter your Verification Code',
        callVerification:'Enter the 5-digit verification code we sent to:', codeSent:'Code Sent to Number Ending in ',
        resendCode:'Resend code', verify:'Verify', sendCodeToDiffPhn:'Choose a different method',
        noPhnNumErrMsg: 'A phone number has not yet been associated with your account. Please call 1-800-284-2365 to speak with a representative.',
        invalidVerifyCode1: 'The code is invalid or expired.', invalidVerifyCode2: 'Request a new code below.',
        limitExceedErrorMsg: 'You have temporarily exceeded the resend-code limit. Please try again in 30 minutes.',
        resendErrMsg1: 'We were unable to resend your code. ', resendErrMsg2: 'Please try again in 1 minute.',resendSentMsg: 'Verification code sent.',
        textMeOrCallMeErrorMessage: 'Code did not send',textMeOrCallMeErrorResubmit:'Something went wrong on our end. Please try sending the code again.', numbers:'[0-9]{3}[-][0-9]{3}[-][0-9]{4}',
        continue:'CONTINUE',
        
      },
      es: {
        guestPreferenceLabel: 'Elija cómo acceder a sus preferencias', ratePreferenceLabel: 'Inicie sesión o verifique su identidad para enviar la solicitud de cambio de tarifa', logInLabel: 'Iniciar Sesión', or: 'O',
        resendErrMsg1:'No pudimos reenviar su código. ',resendErrMsg2:'Inténtalo de nuevo en 1 minuto.', textMe:'ENVÍAME UN MENSAJE',verify:'VERIFICAR', callMe:'LLÁMAME', sendCode: 'ENVIAR CÓDIGO', cancel:'CANCELAR',oneTimeCode:'Código de un solo uso',resendSentMsg:'Código de verificación enviado.',textMeOrCallMeErrorResubmit:'Algo salió mal por nuestra parte. Intente enviar el código nuevamente.',resendCode:'Reenviar código',errorCodeEmpty:'Por favor ingresa un código de verificación válido',invalidCode:'Parece que el código que ingresaste puede haber caducado o es incorrecto. Haga clic en "Reenviar código" para que se envíe un nuevo código a su dispositivo.', ok:'DE ACUERDO',textMeOrCallMeErrorMessage:'Código no enviado',
        verifyPhoneFooter:`Si desea utilizar un número que no figura aquí para verificar su identidad, llame al <span style='color:#1A76C5'>1-800-284-2365</span> para hablar con un representante.`,sendCodeToDiffPhn:'Elige un método diferente',limitExceedErrorMsg:'Ha excedido temporalmente el límite de código de reenvío. Inténtalo de nuevo en 30 minutos.',
        codeNotReceivedQn:'¿No recibiste un código o necesitas otro?',noPhNum:'Sin número de teléfono',codeSent:'Código enviado al número que termina en ',verificationCode:'Ingrese su código de verificación',verifyPhoneSubText:'Para garantizar la seguridad de su cuenta, le enviaremos un código de verificación a un número de teléfono que tenemos registrado.', noPhnNumErrMsg: "Aún no se ha asociado un número de teléfono a su cuenta. Por favor, llame al 1-800-284-2365 para hablar con un representante.",
      },
      zh: {
        guestPreferenceLabel: '选择如何访问您的偏好设置', ratePreferenceLabel: '登录或验证您的身份以提交费率更改请求', logInLabel: '登录', or: '或',
        resendErrMsg1:'我们无法重新发送您的代码。 ',resendErrMsg2:'请 1 分钟后重试。', textMe:'发短信给我', callMe:'打电话给我',verify:'核实', sendCode: '发送代码', cancel:'取消',oneTimeCode:'一次性代码',errorCodeEmpty:'请输入有效的验证码',resendSentMsg:'验证码已发送。',sendCodeToDiffPhn:'选择不同的方法',limitExceedErrorMsg:'您暂时超出了重新发送代码的限制。请在 30 分钟后重试。',resendCode:'重新发送代码',
        verifyPhoneFooter:`如果您希望使用此处未列出的号码来验证您的身份，请致电 <span style='color:#1A76C5'>1-800-284-2365</span> 与代表联系。`,invalidCode:'您输入的代码可能已过期或不正确。单击“重新发送代码”，将新代码发送到您的设备。',textMeOrCallMeErrorResubmit:'我们这边出了点问题。请尝试再次发送代码。',ok:'好的',verifyPhoneSubText:'为了确保您帐户的安全，我们会将验证码发送到我们存档的电话号码。',
        codeNotReceivedQn:'没有收到代码或需要另一个代码？',noPhNum:'没有电话号码',codeSent:'代码已发送至以 结尾的号码 ',verificationCode:'输入您的验证码',textMeOrCallMeErrorMessage:'代码未发送', noPhnNumErrMsg: "尚未将电话号码与您的帐户关联。请致电 1-800-284-2365 与代表联系。",
      },
      vi: {
        guestPreferenceLabel: 'Chọn cách truy cập Tùy chọn của bạn', ratePreferenceLabel: 'Đăng nhập hoặc Xác minh Danh tính của bạn để gửi yêu cầu thay đổi Tỷ lệ', logInLabel: 'Đăng Nhập', or: 'HOẶC',
        resendErrMsg1:'Chúng tôi không thể gửi lại mã của bạn. ',resendErrMsg2:'Vui lòng thử lại sau 1 phút.', textMe:'NHẮN TIN CHO TÔI', callMe:'GỌI CHO TÔI',verify:'XÁC MINH', sendCode: 'GỬI MÃ', cancel:'HỦY BỎ',oneTimeCode:'Mã một lần',errorCodeEmpty:'Vui lòng nhập mã xác minh hợp lệ',sendCodeToDiffPhn:'Chọn một phương pháp khác',ok:'ĐƯỢC RỒI',textMeOrCallMeErrorMessage:'Mã không được gửi',
        invalidCode:'Có vẻ như mã bạn nhập đã hết hạn hoặc không chính xác. Nhấp vào "Gửi lại mã" để gửi mã mới đến thiết bị của bạn.',resendSentMsg:'Mã xác minh đã được gửi.',textMeOrCallMeErrorResubmit:'Đã xảy ra lỗi ở phía chúng tôi. Vui lòng thử gửi lại mã.',resendCode:'Gửi lại mã',
        verifyPhoneFooter:`Nếu bạn muốn sử dụng một số không được liệt kê ở đây để xác minh danh tính của mình, vui lòng gọi <span style='color:#1A76C5'>1-800-284-2365</span> để nói chuyện với người đại diện.`,limitExceedErrorMsg:'Bạn đã tạm thời vượt quá giới hạn mã gửi lại. Vui lòng thử lại sau 30 phút.',
        codeNotReceivedQn:'Không nhận được mã hoặc cần mã khác?',noPhNum:'Không có số điện thoại',codeSent:'Mã được gửi tới số kết thúc bằng ',verificationCode:'Nhập Mã xác minh của bạn',verifyPhoneSubText:'Để đảm bảo tính bảo mật cho tài khoản của bạn, chúng tôi sẽ gửi mã xác minh đến số điện thoại mà chúng tôi có trong hồ sơ.',
        noPhnNumErrMsg: "Số điện thoại chưa được liên kết với tài khoản của bạn. Vui lòng gọi 1-800-284-2365 để nói chuyện với đại diện.",
      },
      ko: {
        guestPreferenceLabel: '환경 설정에 액세스하는 방법 선택', ratePreferenceLabel: '요금 변경 요청을 제출하려면 로그인하거나 신원을 확인하세요', logInLabel: '로그인', or: '또는',
        resendErrMsg1:'코드를 다시 보낼 수 없습니다. ',resendErrMsg2:'1분 후에 다시 시도해 주세요.', textMe:'나에게 문자를 보내세요', callMe:'나에게 전화',verify:'확인하다', sendCode: '코드 보내기', cancel:'취소',oneTimeCode:'일회용 코드',resendSentMsg:'인증 코드가 전송되었습니다.',sendCodeToDiffPhn:'다른 방법을 선택하세요',ok:'좋아요',resendCode:'코드 재전송',
        errorCodeEmpty:'유효한 인증 코드를 입력하세요.',invalidCode:'입력하신 코드가 만료되었거나 잘못된 것 같습니다. 새 코드를 장치로 보내려면 "코드 재전송"을 클릭하세요.',textMeOrCallMeErrorResubmit:'문제가 발생했습니다. 코드를 다시 보내보세요.',
        verifyPhoneFooter:`여기에 나열되지 않은 번호를 사용하여 신원을 확인하려면 <span style='color:#1A76C5'>1-800-284-2365</span> 전화하여 담당자와 통화하세요.`,limitExceedErrorMsg:'재전송 코드 한도를 일시적으로 초과했습니다. 30분 후에 다시 시도해 주세요.',textMeOrCallMeErrorMessage:'코드가 전송되지 않았습니다',
        codeNotReceivedQn:'코드를 받지 못했거나 다른 코드가 필요합니까?',noPhNum:'전화번호 없음',codeSent:'다음으로 끝나는 번호로 코드가 전송되었습니다. ',verificationCode:'인증 코드를 입력하세요',verifyPhoneSubText:'귀하의 계정 보안을 보장하기 위해 등록된 전화번호로 인증 코드를 보내드립니다.', noPhnNumErrMsg: "전화번호가 아직 계정에 연결되지 않았습니다. 담당자와 통화하려면 1-800-284-2365로 전화하십시오.",
      }
    },
    common: ['globalError']
  },
  SelectBp: {
    strings: {
      en: {
        continue: 'Continue >', verifyIdentity: 'VERIFY YOUR IDENTITY', cancel: 'CANCEL', selectBp:'Select an Account',
        bpHeader: 'We found an existing account with information similar to your entry. Please select the correct account you want to register',
        bpHeaderGuest:'We found multiple accounts that are similar to your entry. Please select the correct one.',
      },
      es: {
        continue: 'Continuar >', verifyIdentity: 'VERIFICA TU IDENTIDAD', cancel: 'CANCELAR', selectBp:'Seleccione una cuenta',
        bpHeader: 'Encontramos una cuenta existente con información similar a su entrada. Por favor seleccione la cuenta correcta que desea registrar',
        bpHeaderGuest:'Encontramos varias cuentas similares a su entrada. Por favor seleccione el correcto.', 
      },
      zh: {
        continue: '继续 >', verifyIdentity: '验证您的身份', cancel: '取消', selectBp:'选择一个帐户',
        bpHeader: '我们发现一个现有帐户的信息与您的条目类似。请选择您要注册的正确账户',
        bpHeaderGuest: '我们发现多个帐户与您的条目相似。请选择正确的一项',
      },
      vi: {
        continue: 'Tiếp Tục >', verifyIdentity: 'XÁC MINH DANH TÍNH CỦA BẠN', cancel: 'HỦY BỎ', selectBp:'Chọn một tài khoản',
        bpHeader: 'Chúng tôi đã tìm thấy một tài khoản hiện có có thông tin tương tự với mục nhập của bạn. Vui lòng chọn đúng tài khoản bạn muốn đăng ký',
        bpHeaderGuest: 'Chúng tôi đã tìm thấy nhiều tài khoản tương tự với mục nhập của bạn. Vui lòng chọn đúng.',
      },
      ko: {
        continue: '계속 >', verifyIdentity: '신원을 확인하세요', cancel: '취소', selectBp: '계정을 선택하세요',
        bpHeader: '귀하의 항목과 유사한 정보를 가진 기존 계정을 찾았습니다. 등록하려는 올바른 계정을 선택하세요.',
        bpHeaderGuest: '귀하의 항목과 유사한 계정이 여러 개 발견되었습니다. 올바른 것을 선택하세요.',
      }
    },
    common: ['globalError']
  },
};
export const getLocalizedStrings = (componentName) => {
  app.logger.getLogger().debug("Comp Name" + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
  // return new LocalizedStrings(strings);
};
